import { isArray } from "../../utils/type"; // eslint-disable-next-line consistent-return

export var datesArrayToDateString = function datesArrayToDateString(date) {
  if (date) {
    if (isArray(date)) {
      var fullDate = date.every(function (element) {
        return element.length > 0;
      });

      if (fullDate) {
        return date.join('-');
      }

      return date[0];
    }

    return date;
  }

  return '';
};